module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAHklEQVQ4y2NgGBygPfA/OkYH2NSMGjBqwGAzYEgDAL+qecKlfTxoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NG.png
// module id = 1227
// module chunks = 0